export interface Movie {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  description: string;
  fullDescription: string;
  coverImage: string;
  tags: string[];
  director: string;
  actors: string[];
  duration: string;
  region: string;
  updateDate: string;
  views: number;
  isHot: boolean;
  isNew: boolean;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { slug: 'all', name: '全部', icon: 'ri-movie-line', count: 48 },
  { slug: 'movie', name: '电影', icon: 'ri-film-line', count: 16 },
  { slug: 'tv-series', name: '电视剧', icon: 'ri-tv-line', count: 14 },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line', count: 8 },
  { slug: 'anime', name: '动漫', icon: 'ri-ancient-gate-line', count: 6 },
  { slug: 'documentary', name: '纪录片', icon: 'ri-slideshow-line', count: 4 },
];

export const movies: Movie[] = [
  {
    id: 'm1',
    title: '长安三万里',
    category: '动漫',
    categorySlug: 'anime',
    year: 2023,
    rating: 8.3,
    description: '安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。',
    fullDescription: '安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。影片以高适的视角，讲述了李白跌宕起伏的一生，以及大唐由盛转衰的历史变迁。两人从少年相识，到青年相知，再到中年各奔东西，最终在暮年以不同的方式完成了各自的使命。影片通过精美的画面和动人的音乐，再现了盛唐气象和诗人的豪情壮志，是一部兼具艺术性和观赏性的动画电影佳作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20Chang%20An%20San%20Wan%20Li%20movie%20poster%20style%20with%20ancient%20Chinese%20poet%20in%20Tang%20dynasty%20setting%2C%20warm%20golden%20tones%2C%20artistic%20illustration%2C%20cinematic%20poster%20design%20with%20dramatic%20lighting&width=600&height=800&seq=movie-m1&orientation=portrait',
    tags: ['动画', '历史', '传记', '盛唐'],
    director: '谢君伟 / 邹靖',
    actors: ['杨天翔', '凌振赫', '吴俊全', '宣晓鸣'],
    duration: '168分钟',
    region: '中国大陆',
    updateDate: '2026-08-01',
    views: 1285000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'm2',
    title: '流浪地球2',
    category: '电影',
    categorySlug: 'movie',
    year: 2023,
    rating: 8.4,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    fullDescription: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。本片以提出计划建造1万座行星发动机的时代为故事背景，讲述了"太阳危机"即将来袭，世界陷入一片恐慌之中，万座行星发动机正在建造中，人类将面临末日灾难与生命存续的双重挑战。影片特效震撼，情节紧凑，是中国科幻电影的里程碑之作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20film%20The%20Wandering%20Earth%202%20movie%20poster%20style%20with%20astronaut%20and%20massive%20planet%20in%20background%2C%20futuristic%20cinematic%20poster%20design%2C%20dark%20blue%20and%20orange%20tones%2C%20dramatic%20composition&width=600&height=800&seq=movie-m2&orientation=portrait',
    tags: ['科幻', '冒险', '灾难', '太空'],
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    duration: '173分钟',
    region: '中国大陆',
    updateDate: '2026-07-28',
    views: 2560000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'm3',
    title: '满江红',
    category: '电影',
    categorySlug: 'movie',
    year: 2023,
    rating: 7.8,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进这巨大阴谋之中。',
    fullDescription: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进这巨大阴谋之中。宰相秦桧限两人一个时辰之内找到凶手。伴随危机四伏的深入调查，真相层层剥开，谜底也渐渐浮出水面。影片融合悬疑、喜剧和历史元素，讲述了一个关于忠诚与牺牲的动人故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20film%20Man%20Jiang%20Hong%20movie%20poster%20style%20with%20ancient%20Chinese%20soldiers%20in%20Song%20dynasty%2C%20red%20and%20dark%20atmospheric%20poster%20design%2C%20cinematic%20mystery%20thriller%20aesthetic&width=600&height=800&seq=movie-m3&orientation=portrait',
    tags: ['剧情', '喜剧', '悬疑', '古装'],
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    duration: '159分钟',
    region: '中国大陆',
    updateDate: '2026-07-25',
    views: 1890000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'm4',
    title: '繁花',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2024,
    rating: 8.7,
    description: '九十年代的上海处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼跻身成为商界后起之秀，黄河路上无人不晓。平凡阿宝蜕变为宝总，离不开高人爷叔与夜东京老板玲子、外贸大楼汪小姐的鼎力协助。',
    fullDescription: '九十年代的上海处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼跻身成为商界后起之秀，黄河路上无人不晓。平凡阿宝蜕变为宝总，离不开高人爷叔与夜东京老板玲子、外贸大楼汪小姐的鼎力协助。随着神秘女子李李空降黄河路，一家时髦饭店即将搅动整条街，也令宝总原本决胜千里的事业变得动荡惊心，他与身边人的关系也经受着前所未有的考验。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20Fan%20Hua%20Blossoms%20Shanghai%20poster%20style%20with%201990s%20Shanghai%20street%20scene%2C%20retro%20nostalgic%20atmosphere%2C%20warm%20golden%20lighting%2C%20elegant%20Chinese%20drama%20poster%20design&width=600&height=800&seq=movie-m4&orientation=portrait',
    tags: ['剧情', '爱情', '年代', '商战'],
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    duration: '30集',
    region: '中国大陆',
    updateDate: '2026-08-02',
    views: 3560000,
    isHot: true,
    isNew: true,
  },
  {
    id: 'm5',
    title: '庆余年第二季',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2024,
    rating: 8.1,
    description: '范闲经历生死后再度归来，面对更为复杂的朝堂局势和更强大的敌人，他能否凭借智慧与勇气再次化险为夷？',
    fullDescription: '范闲经历生死后再度归来，面对更为复杂的朝堂局势和更强大的敌人，他能否凭借智慧与勇气再次化险为夷？本季剧情承接上一季，范闲在经历了一系列惊心动魄的事件后，逐渐揭开了自己身世之谜，也卷入了更为深重的权力漩涡之中。朝堂之上暗流涌动，江湖之中危机四伏，范闲需要在各方势力的夹缝中寻找生存之道，同时守护自己珍视的人和事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20Joy%20of%20Life%20Season%202%20TV%20series%20poster%20with%20ancient%20Chinese%20warrior%20in%20traditional%20costume%2C%20cinematic%20dramatic%20lighting%2C%20epic%20historical%20fantasy%20poster%20design&width=600&height=800&seq=movie-m5&orientation=portrait',
    tags: ['古装', '权谋', '奇幻', '冒险'],
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    duration: '36集',
    region: '中国大陆',
    updateDate: '2026-07-30',
    views: 4120000,
    isHot: true,
    isNew: true,
  },
  {
    id: 'm6',
    title: '消失的她',
    category: '电影',
    categorySlug: 'movie',
    year: 2023,
    rating: 7.5,
    description: '何非的妻子李木子在结婚周年旅行中离奇消失，当他苦寻无果之时，妻子再次现身，何非却坚称眼前的女人并非自己的妻子。夫妻二人似乎都有着不可告人的秘密。',
    fullDescription: '何非的妻子李木子在结婚周年旅行中离奇消失，当他苦寻无果之时，妻子再次现身，何非却坚称眼前的女人并非自己的妻子。夫妻二人似乎都有着不可告人的秘密。影片以层层递进的悬疑叙事，将观众带入一个充满欺骗与真相的迷局之中。随着金牌律师陈麦的介入，更多谜团浮出水面，真相愈发扑朔迷离。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20film%20Lost%20in%20the%20Stars%20movie%20poster%20with%20mysterious%20woman%20silhouette%2C%20dark%20atmospheric%20noir%20style%2C%20thriller%20cinematic%20poster%20design%20with%20dramatic%20contrast&width=600&height=800&seq=movie-m6&orientation=portrait',
    tags: ['悬疑', '犯罪', '剧情', '惊悚'],
    director: '崔睿 / 刘翔',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    duration: '121分钟',
    region: '中国大陆',
    updateDate: '2026-07-22',
    views: 1670000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm7',
    title: '狂飙',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2023,
    rating: 8.9,
    description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，一举铲除了盘踞京海多年的强盛集团。',
    fullDescription: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，一举铲除了盘踞京海多年的强盛集团。该剧以扫黑除恶为主题的现实主义题材作品，通过一个菜市场鱼贩成长为黑社会老大的故事，深刻揭露了黑恶势力形成的深层原因，展现了一线刑警二十年如一日的坚守与信仰。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20The%20Knockout%20TV%20series%20poster%20with%20two%20men%20facing%20each%20other%2C%20dark%20urban%20atmosphere%2C%20police%20drama%20cinematic%20poster%20design%2C%20intense%20moody%20lighting&width=600&height=800&seq=movie-m7&orientation=portrait',
    tags: ['剧情', '犯罪', '扫黑', '现实主义'],
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    duration: '39集',
    region: '中国大陆',
    updateDate: '2026-07-20',
    views: 5230000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'm8',
    title: '封神第一部',
    category: '电影',
    categorySlug: 'movie',
    year: 2023,
    rating: 7.9,
    description: '商王殷寿与狐妖妲己勾结，暴虐无道，引发天谴。昆仑仙人姜子牙携"封神榜"下山，寻找天下共主，以救苍生。西伯侯之子姬发逐渐发现殷寿的本来面目，反出朝歌。',
    fullDescription: '商王殷寿与狐妖妲己勾结，暴虐无道，引发天谴。昆仑仙人姜子牙携"封神榜"下山，寻找天下共主，以救苍生。西伯侯之子姬发逐渐发现殷寿的本来面目，反出朝歌。影片以宏大的史诗叙事，再现了中国古典神话《封神演义》的开篇故事。影片在视觉效果上实现了中国奇幻电影的突破，神仙斗法场面气势磅礴，人物塑造饱满立体。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20Creation%20of%20the%20Gods%20movie%20poster%20with%20ancient%20Chinese%20warriors%20and%20mythical%20creatures%2C%20epic%20cinematic%20poster%20design%2C%20golden%20and%20red%20dramatic%20tones&width=600&height=800&seq=movie-m8&orientation=portrait',
    tags: ['奇幻', '古装', '史诗', '神话'],
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    duration: '148分钟',
    region: '中国大陆',
    updateDate: '2026-07-18',
    views: 2010000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm9',
    title: '三体',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2023,
    rating: 8.2,
    description: '2007年，地球基础科学出现了异常的扰动，一时间科学界风雨飘飘，人心惶惶。纳米科学家汪淼进入神秘的网络游戏《三体》，开始逐步逼近这个世界的真相。',
    fullDescription: '2007年，地球基础科学出现了异常的扰动，一时间科学界风雨飘飘，人心惶惶。离奇自杀的科学家，近乎神迹的倒计时，行事隐秘的科学边界，神秘莫测的《三体》游戏。纳米科学家汪淼被警官史强带到联合作战中心，并潜入名为"科学边界"的组织协助调查。迷雾之中，汪淼接触到名为"eto"的组织，发现其幕后统帅竟是自杀身亡的科学家杨冬的母亲叶文洁。随着调查深入，一个关于宇宙文明的巨大秘密逐渐浮出水面。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20Three%20Body%20TV%20series%20poster%20with%20three%20suns%20in%20space%2C%20mysterious%20cosmic%20atmosphere%2C%20futuristic%20dark%20cinematic%20poster%20design&width=600&height=800&seq=movie-m9&orientation=portrait',
    tags: ['科幻', '悬疑', '剧情', '宇宙'],
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    duration: '30集',
    region: '中国大陆',
    updateDate: '2026-07-15',
    views: 2890000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm10',
    title: '乘风破浪的姐姐',
    category: '综艺',
    categorySlug: 'variety',
    year: 2024,
    rating: 7.6,
    description: '三十位30+女性艺人再次集结，通过舞台竞演展现成熟女性的魅力与实力，打破年龄界限，重新定义女性价值。',
    fullDescription: '三十位30+女性艺人再次集结，通过舞台竞演展现成熟女性的魅力与实力，打破年龄界限，重新定义女性价值。本季节目邀请来自不同领域的姐姐们参与竞演，包括演员、歌手、主持人、舞者等。她们将组成不同的团队，通过一次次舞台表演，展现女性的多样魅力，传递"三十而骊"的积极人生态度。节目不仅是一场视听盛宴，更是一次关于女性力量的深度探讨。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20Sisters%20Who%20Make%20Waves%20poster%20with%20multiple%20elegant%20women%20on%20stage%2C%20glamorous%20showbiz%20poster%20design%2C%20bright%20colorful%20stage%20lighting&width=600&height=800&seq=movie-m10&orientation=portrait',
    tags: ['综艺', '音乐', '竞演', '女性'],
    director: '芒果TV',
    actors: ['宁静', '那英', '王心凌', '郑秀妍'],
    duration: '12期',
    region: '中国大陆',
    updateDate: '2026-07-10',
    views: 1980000,
    isHot: false,
    isNew: true,
  },
  {
    id: 'm11',
    title: '深海',
    category: '动漫',
    categorySlug: 'anime',
    year: 2023,
    rating: 7.4,
    description: '在大海的最深处，藏着所有秘密。一位现代少女参宿误入梦幻的深海世界，却因此邂逅了一段独特的生命旅程。',
    fullDescription: '在大海的最深处，藏着所有秘密。一位现代少女参宿误入梦幻的深海世界，却因此邂逅了一段独特的生命旅程。影片以独特的"粒子水墨"技术，创造出了一个前所未有的视觉奇观。故事讲述了一个在重组家庭中感到孤独的少女参宿，意外坠入深海之后遇到的一个神秘的海底世界。在这里，她遇到了一位叫南河的青年，两人一起经历了一段奇幻的冒险旅程。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20Deep%20Sea%20movie%20poster%20with%20colorful%20underwater%20world%20and%20a%20young%20girl%2C%20dreamlike%20ink%20painting%20style%2C%20magical%20surreal%20cinematic%20poster&width=600&height=800&seq=movie-m11&orientation=portrait',
    tags: ['动画', '奇幻', '冒险', '治愈'],
    director: '田晓鹏',
    actors: ['苏鑫', '王亭文', '滕奎兴', '杨婷'],
    duration: '112分钟',
    region: '中国大陆',
    updateDate: '2026-07-08',
    views: 890000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm12',
    title: '我和我的父辈',
    category: '电影',
    categorySlug: 'movie',
    year: 2021,
    rating: 7.1,
    description: '由四个单元组成，讲述了不同历史时期、各个代表性阶层群体不忘初心、砥砺前行的奋斗历程，以家庭关系为载体，反映时代的变迁和民族精神的传承延续。',
    fullDescription: '由四个单元组成，讲述了不同历史时期、各个代表性阶层群体不忘初心、砥砺前行的奋斗历程，以家庭关系为载体，反映时代的变迁和民族精神的传承延续。四个故事分别由吴京、章子怡、徐峥、沈腾执导并主演，涵盖了抗日战争时期、新中国建设时期、改革开放初期和未来科技时代。每个故事都以"我"和"我的父辈"为核心，展现了不同时代背景下的父子情、母子情，以及家国情怀。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20patriotic%20film%20My%20Country%20My%20Parents%20movie%20poster%20with%20multiple%20generations%20of%20Chinese%20family%2C%20warm%20nostalgic%20tones%2C%20emotional%20cinematic%20poster%20design&width=600&height=800&seq=movie-m12&orientation=portrait',
    tags: ['剧情', '家庭', '历史', '爱国'],
    director: '吴京 / 章子怡 / 徐峥 / 沈腾',
    actors: ['吴京', '章子怡', '徐峥', '沈腾'],
    duration: '157分钟',
    region: '中国大陆',
    updateDate: '2026-07-05',
    views: 1120000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm13',
    title: '向往的生活',
    category: '综艺',
    categorySlug: 'variety',
    year: 2024,
    rating: 7.3,
    description: '一起回归田园，过上自给自足的慢生活。每期都有老朋友和新朋友带来新的故事和温暖的瞬间。',
    fullDescription: '一起回归田园，过上自给自足的慢生活。每期都有老朋友和新朋友带来新的故事和温暖的瞬间。节目以"慢"为核心理念，记录了主持人和嘉宾们在远离城市喧嚣的乡村中，一起劳作、做饭、聊天的日常生活。在蘑菇屋的院子里，明星们卸下了光环和包袱，展现出最真实自然的一面。这里没有激烈的竞争，没有复杂的游戏规则，只有一日三餐、柴米油盐和温暖的人情味。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20Back%20to%20Field%20poster%20with%20countryside%20rural%20scenery%2C%20warm%20pastoral%20atmosphere%2C%20cozy%20outdoor%20garden%20setting%2C%20relaxed%20lifestyle%20poster&width=600&height=800&seq=movie-m13&orientation=portrait',
    tags: ['综艺', '生活', '慢综艺', '田园'],
    director: '湖南卫视',
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅'],
    duration: '14期',
    region: '中国大陆',
    updateDate: '2026-07-02',
    views: 1560000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm14',
    title: '白蛇：缘起',
    category: '动漫',
    categorySlug: 'anime',
    year: 2019,
    rating: 7.8,
    description: '晚唐年间，国师发动民众大量捕蛇。前去刺杀国师的白蛇意外失忆，被捕蛇村少年阿宣救下。两人历经艰难产生感情，但白蛇妖的身份逐渐暴露。',
    fullDescription: '晚唐年间，国师发动民众大量捕蛇。前去刺杀国师的白蛇意外失忆，被捕蛇村少年阿宣救下。两人历经艰难产生感情，但白蛇妖的身份逐渐暴露。影片改编自中国民间传说《白蛇传》，讲述了白蛇与许仙五百年前的前世情缘。影片画面精美绝伦，将中国传统水墨画风与现代3D动画技术完美融合。故事在经典传说的基础上进行了创新改编，赋予了角色更为丰富的情感和动机。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20White%20Snake%20movie%20poster%20with%20beautiful%20woman%20in%20traditional%20Chinese%20dress%2C%20ink%20wash%20painting%20style%2C%20romantic%20ancient%20Chinese%20aesthetic&width=600&height=800&seq=movie-m14&orientation=portrait',
    tags: ['动画', '爱情', '奇幻', '古风'],
    director: '黄家康 / 赵霁',
    actors: ['张喆', '杨天翔', '唐小喜', '刘紫玲'],
    duration: '99分钟',
    region: '中国大陆',
    updateDate: '2026-06-28',
    views: 720000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm15',
    title: '隐秘的角落',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2020,
    rating: 8.8,
    description: '沿海小城的三个孩子在景区游玩时，无意拍摄记录了一次谋杀。他们的冒险也由此展开，几个家庭被裹挟其中，带向不可预知的未来。',
    fullDescription: '沿海小城的三个孩子在景区游玩时，无意拍摄记录了一次谋杀。他们的冒险也由此展开，几个家庭被裹挟其中，带向不可预知的未来。该剧改编自紫金陈推理小说《坏小孩》，讲述了一个关于人性的黑暗童话。表面上这是一部悬疑剧，但实际上探讨了原生家庭、成长环境对儿童心理发展的深层影响。剧中的"爬山梗"和"小白船"更是在播出后引发了全网热议，成为现象级社会话题。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20thriller%20drama%20The%20Bad%20Kids%20TV%20series%20poster%20with%20three%20children%20in%20dark%20atmospheric%20setting%2C%20mystery%20suspense%20poster%20design%2C%20moody%20noir%20cinematic%20style&width=600&height=800&seq=movie-m15&orientation=portrait',
    tags: ['悬疑', '犯罪', '剧情', '家庭'],
    director: '辛爽',
    actors: ['秦昊', '王景春', '荣梓杉', '史彭元'],
    duration: '12集',
    region: '中国大陆',
    updateDate: '2026-06-25',
    views: 3450000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm16',
    title: '舌尖上的中国',
    category: '纪录片',
    categorySlug: 'documentary',
    year: 2012,
    rating: 9.4,
    description: '围绕中国人对美食和生活的美好追求，用具体人物故事串联起讲述了中国各地的美食生态。',
    fullDescription: '围绕中国人对美食和生活的美好追求，用具体人物故事串联起讲述了中国各地的美食生态。影片通过对中国各地特色美食的深入探访，展现了食物与人之间的深厚关系。从广袤的草原到深邃的海洋，从繁华的都市到偏远的山村，节目组走遍中国的大江南北，记录下了一个个关于美食与生活的动人故事。这不仅是一部关于食物的纪录片，更是一部关于中国人生活智慧和情感记忆的影像志。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20A%20Bite%20of%20China%20poster%20with%20delicious%20Chinese%20cuisine%20and%20chopsticks%2C%20warm%20food%20photography%20style%2C%20cultural%20documentary%20poster%20design&width=600&height=800&seq=movie-m16&orientation=portrait',
    tags: ['纪录片', '美食', '文化', '人文'],
    director: '陈晓卿',
    actors: ['李立宏'],
    duration: '7集',
    region: '中国大陆',
    updateDate: '2026-06-20',
    views: 4320000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm17',
    title: '大山的女儿',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2022,
    rating: 8.5,
    description: '黄文秀从北京师范大学研究生毕业后，放弃大城市工作机会，回到家乡百色担任驻村第一书记，奋战在脱贫攻坚第一线。',
    fullDescription: '黄文秀从北京师范大学研究生毕业后，放弃大城市工作机会，回到家乡百色担任驻村第一书记，奋战在脱贫攻坚第一线。该剧以真实人物黄文秀为原型，讲述了这位年轻共产党员将生命奉献给扶贫事业的感人事迹。黄文秀以满腔热血和无私奉献的精神，带领村民发展产业、改善生活条件，用短暂而精彩的一生诠释了共产党人的初心使命。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20Daughter%20of%20the%20Mountain%20poster%20with%20young%20woman%20in%20rural%20Chinese%20village%2C%20warm%20inspiring%20atmosphere%2C%20realistic%20drama%20poster%20design&width=600&height=800&seq=movie-m17&orientation=portrait',
    tags: ['剧情', '传记', '扶贫', '正能量'],
    director: '雷献禾',
    actors: ['杨蓉', '刘奕君', '涓子', '李君峰'],
    duration: '30集',
    region: '中国大陆',
    updateDate: '2026-06-18',
    views: 920000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm18',
    title: '王牌对王牌',
    category: '综艺',
    categorySlug: 'variety',
    year: 2024,
    rating: 7.2,
    description: '两大王牌团队进行游戏对决，经典IP阵容重现舞台，欢乐与感动并存的大型室内竞技综艺节目。',
    fullDescription: '两大王牌团队进行游戏对决，经典IP阵容重现舞台，欢乐与感动并存的大型室内竞技综艺节目。每期节目邀请不同的经典影视剧组重聚，通过游戏环节和才艺展示，带领观众重温经典，唤醒青春记忆。节目以轻松幽默的方式展现明星们的真实一面，既有紧张刺激的游戏对抗，也有温情脉脉的重聚时刻。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20Trump%20Card%20poster%20with%20celebrities%20on%20colorful%20stage%2C%20entertainment%20game%20show%20atmosphere%2C%20vibrant%20poster%20design%20with%20stage%20lights&width=600&height=800&seq=movie-m18&orientation=portrait',
    tags: ['综艺', '游戏', '喜剧', '经典重现'],
    director: '浙江卫视',
    actors: ['沈腾', '贾玲', '华晨宇', '关晓彤'],
    duration: '12期',
    region: '中国大陆',
    updateDate: '2026-06-15',
    views: 1340000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm19',
    title: '雄狮少年',
    category: '动漫',
    categorySlug: 'anime',
    year: 2021,
    rating: 8.4,
    description: '三个被人无视和欺负的少年，阴差阳错走上舞狮之路，拜师退役狮王咸鱼强，经过重重磨砺，从病猫变成雄狮。',
    fullDescription: '三个被人无视和欺负的少年，阴差阳错走上舞狮之路，拜师退役狮王咸鱼强，经过重重磨砺，从病猫变成雄狮。影片以岭南醒狮文化为背景，讲述了一群底层少年逆袭追梦的热血故事。影片在传承中国传统文化的同时，也展现了当代农村留守儿童的生活现状，兼具娱乐性和社会意义。动画制作精良，狮头舞动的每一个细节都经过精心雕琢，呈现出令人惊叹的视觉效果。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20I%20Am%20What%20I%20Am%20dance%20lion%20poster%20with%20boy%20and%20Chinese%20lion%20dance%2C%20vibrant%20red%20and%20gold%20poster%20design%2C%20inspiring%20sports%20animation%20style&width=600&height=800&seq=movie-m19&orientation=portrait',
    tags: ['动画', '励志', '喜剧', '醒狮'],
    director: '孙海鹏',
    actors: ['大昕', '大雄', '郭皓', '李盟'],
    duration: '104分钟',
    region: '中国大陆',
    updateDate: '2026-06-12',
    views: 630000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm20',
    title: '航拍中国',
    category: '纪录片',
    categorySlug: 'documentary',
    year: 2022,
    rating: 9.1,
    description: '以空中视角俯瞰中国，立体化展示中国历史人文、地理风貌及社会形态，让观众以一个全新的角度看到美丽中国。',
    fullDescription: '以空中视角俯瞰中国，立体化展示中国历史人文、地理风貌及社会形态，让观众以一个全新的角度看到美丽中国。节目使用无人机和载人直升机进行大规模航拍，覆盖中国23个省、5个自治区、4个直辖市和2个特别行政区。从新疆的广袤戈壁到海南的热带雨林，从黑龙江的冰雪世界到云南的四季如春，每一帧画面都令人叹为观止，展示了祖国大地的壮美与多样。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20Aerial%20China%20poster%20with%20stunning%20aerial%20landscape%20view%20of%20Chinese%20mountains%20and%20rivers%2C%20epic%20nature%20photography%20style%2C%20national%20geographic%20documentary%20poster&width=600&height=800&seq=movie-m20&orientation=portrait',
    tags: ['纪录片', '自然', '地理', '航拍'],
    director: '央视纪录',
    actors: ['李立宏'],
    duration: '10集',
    region: '中国大陆',
    updateDate: '2026-06-10',
    views: 2100000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm21',
    title: '孤注一掷',
    category: '电影',
    categorySlug: 'movie',
    year: 2023,
    rating: 7.3,
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手，从他们身上套现完成业绩。',
    fullDescription: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手，从他们身上套现完成业绩。影片以真实案例为蓝本，首次全方位揭露境外网络诈骗全产业链内幕。从被骗者的遭遇、诈骗团伙的运作模式、到警方打击的全过程，立体呈现了这一严重危害社会的犯罪形态，具有强烈的社会警示意义。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20film%20No%20More%20Bets%20movie%20poster%20with%20mysterious%20figure%20in%20dark%20room%2C%20intense%20thriller%20atmosphere%2C%20cyber%20crime%20theme%20cinematic%20poster&width=600&height=800&seq=movie-m21&orientation=portrait',
    tags: ['犯罪', '剧情', '社会', '反诈'],
    director: '申奥',
    actors: ['张艺兴', '金晨', '咏梅', '王传君'],
    duration: '130分钟',
    region: '中国大陆',
    updateDate: '2026-06-08',
    views: 1870000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm22',
    title: '地球脉动',
    category: '纪录片',
    categorySlug: 'documentary',
    year: 2023,
    rating: 9.7,
    description: '从南极到北极，从赤道到寒带，从非洲草原到热带雨林，再从荒凉峰顶到深邃大海，难以数计的生物以极其绝美的身姿呈现在世人面前。',
    fullDescription: '从南极到北极，从赤道到寒带，从非洲草原到热带雨林，再从荒凉峰顶到深邃大海，难以数计的生物以极其绝美的身姿呈现在世人面前。这部BBC出品的史诗级自然纪录片，历时四年拍摄，足迹遍布62个国家。通过革命性的拍摄技术，捕捉到了许多前所未知的自然奇观和动物行为。每一集都像一部电影般引人入胜，配以大卫·爱登堡爵士富有感染力的解说，堪称自然纪录片的巅峰之作。',
    coverImage: 'https://readdy.ai/api/search-image?query=BBC%20documentary%20Planet%20Earth%20poster%20with%20stunning%20wildlife%20and%20nature%20landscape%2C%20epic%20nature%20photography%2C%20cinematic%20documentary%20poster%20design%20with%20animals&width=600&height=800&seq=movie-m22&orientation=portrait',
    tags: ['纪录片', '自然', '动物', 'BBC'],
    director: 'BBC',
    actors: ['大卫·爱登堡'],
    duration: '8集',
    region: '英国',
    updateDate: '2026-06-05',
    views: 2780000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm23',
    title: '宇宙探索编辑部',
    category: '电影',
    categorySlug: 'movie',
    year: 2023,
    rating: 8.1,
    description: '唐志军是一家科幻杂志社的主编，一生致力于寻找外星文明。有一天，他接收到了一个疑似来自宇宙深处的异常信号，于是召集同是天涯沦落人的伙伴们，踏上寻找外星人的旅途。',
    fullDescription: '唐志军是一家科幻杂志社的主编，一生致力于寻找外星文明。有一天，他接收到了一个疑似来自宇宙深处的异常信号，于是召集同是天涯沦落人的伙伴们，踏上寻找外星人的旅途。影片以伪纪录片的形式，讲述了一群"边缘人"执着追寻外星文明的荒诞而又温情的故事。影片在幽默的外壳下包裹着深刻的哲学思考，探讨了人类在浩瀚宇宙中的位置和意义。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20sci-fi%20film%20Journey%20to%20the%20West%20movie%20poster%20with%20quirky%20characters%20looking%20at%20stars%2C%20mockumentary%20style%2C%20warm%20humorous%20cinematic%20poster&width=600&height=800&seq=movie-m23&orientation=portrait',
    tags: ['喜剧', '科幻', '伪纪录片', '文艺'],
    director: '孔大山',
    actors: ['杨皓宇', '艾丽娅', '王一通', '蒋奇明'],
    duration: '118分钟',
    region: '中国大陆',
    updateDate: '2026-06-02',
    views: 540000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'm24',
    title: '河西走廊',
    category: '纪录片',
    categorySlug: 'documentary',
    year: 2015,
    rating: 9.6,
    description: '以位于中国西部的重要通道、丝绸之路的黄金段——河西走廊为讲述对象，从政治、军事、经济、文化、宗教等多角度呈现了从汉代至今的历史变迁。',
    fullDescription: '以位于中国西部的重要通道、丝绸之路的黄金段——河西走廊为讲述对象，从政治、军事、经济、文化、宗教等多角度呈现了从汉代至今的历史变迁。该片是中央电视台和甘肃省委宣传部联合出品的一部十集系列纪录片。它撷取河西走廊上的绚烂瞬间，以编年体史诗的形式，跨越汉、三国、两晋、隋唐、蒙元、明清、民国和新中国，系统梳理了河西走廊甚至整个中国西部的历史。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20Hexi%20Corridor%20poster%20with%20ancient%20Silk%20Road%20desert%20landscape%2C%20historical%20Chinese%20civilization%2C%20epic%20cultural%20documentary%20poster%20design&width=600&height=800&seq=movie-m24&orientation=portrait',
    tags: ['纪录片', '历史', '文化', '丝绸之路'],
    director: '赵启辰',
    actors: ['吕树清'],
    duration: '10集',
    region: '中国大陆',
    updateDate: '2026-05-28',
    views: 890000,
    isHot: false,
    isNew: false,
  },
];

export const testimonials = [
  {
    id: 't1',
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20man%20portrait%20headshot%2C%20clean%20studio%20background%2C%20friendly%20expression&width=100&height=100&seq=avatar-t1&orientation=squarish',
    content: '天美麻花星空影视的画质真的没话说，看《繁花》的时候1080P完全不卡顿，比很多付费平台还流畅，强烈推荐！',
    rating: 5,
    date: '2026-07-15',
  },
  {
    id: 't2',
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20woman%20portrait%20headshot%2C%20clean%20studio%20background%2C%20warm%20smile&width=100&height=100&seq=avatar-t2&orientation=squarish',
    content: '分类做得很清晰，想找什么类型的影视剧很快就能找到。资源更新也很及时，新剧一上线就能看。',
    rating: 5,
    date: '2026-07-10',
  },
  {
    id: 't3',
    name: '小王同学',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20student%20portrait%20headshot%2C%20clean%20studio%20background%2C%20casual%20friendly%20expression&width=100&height=100&seq=avatar-t3&orientation=squarish',
    content: '作为一个追剧党，麻花星空真的拯救了我的剧荒！片源超全，从国产剧到纪录片应有尽有，页面也很清爽没有乱七八糟的广告。',
    rating: 5,
    date: '2026-06-28',
  },
  {
    id: 't4',
    name: '陈老师',
    avatar: 'https://readdy.ai/api/search-image?query=middle%20aged%20Chinese%20man%20portrait%20headshot%2C%20clean%20studio%20background%2C%20gentle%20expression&width=100&height=100&seq=avatar-t4&orientation=squarish',
    content: '纪录片区做得很好，《航拍中国》和《河西走廊》都是在麻花星空上看的，高清不缓冲的体验太棒了。',
    rating: 4,
    date: '2026-06-20',
  },
  {
    id: 't5',
    name: '赵女士',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20woman%20portrait%20headshot%2C%20clean%20studio%20background%2C%20elegant%20friendly%20expression&width=100&height=100&seq=avatar-t5&orientation=squarish',
    content: '家里老人小孩都能轻松使用，页面简洁大方。综艺节目更新特别快，《乘风破浪的姐姐》新一期当天就能看上。',
    rating: 5,
    date: '2026-06-15',
  },
];

export const faqs = [
  {
    question: '天美麻花星空影视是否需要注册才能观看？',
    answer: '不需要。天美麻花星空影视完全免费开放，无需注册登录即可畅享所有影视资源，真正做到即点即看、无需等待。',
  },
  {
    question: '麻花星空影视的视频画质如何？是否支持高清播放？',
    answer: '我们提供标清、高清和超清多种画质选择，绝大多数影片支持1080P高清画质。播放流畅不缓冲，您可以根据自己的网络情况自由切换画质。',
  },
  {
    question: '天美麻花星空影视支持哪些设备观看？',
    answer: '我们的网站采用响应式设计，完美适配电脑、平板和手机等多种设备。无论您是在家使用大屏电脑，还是出行中通过手机观看，都能获得流畅的观影体验。',
  },
  {
    question: '影视资源更新速度快吗？',
    answer: '非常快！我们拥有专业的资源更新团队，热门电影、电视剧和综艺节目通常在上线后的24小时内即可在天美麻花星空影视上观看，让您追剧不掉队。',
  },
  {
    question: '麻花星空影视是否有广告打扰？',
    answer: '我们深知广告对观影体验的影响，因此天美麻花星空影视在播放过程中不插入任何强制广告，让您享受纯粹无打扰的观影时光。',
  },
  {
    question: '如何快速找到我想看的影视剧？',
    answer: '您可以通过首页的分类导航快速进入不同影视类型，也可以在分类页面使用筛选功能按类型、年份、地区等条件精准查找，此外我们还提供了搜索功能助您直达目标影片。',
  },
];